import { Box, Button } from '@mui/material';
import { SearchRounded } from '@mui/icons-material';
import { CheckoutPricing } from '../../hooks/checkouts/useCheckoutPricing';
import CheckoutFormItems from './CheckoutFormItems';
import CheckoutFormPricingTable from './CheckoutFormPricingTable';

interface Props {
  pricing: CheckoutPricing;
}

export default function PricingTable({ pricing }: Props) {
  return (
    <Box className="input-group">
      <CheckoutFormItems title={pricing.itemsTitle} items={pricing.items} />

      {pricing.canEditItems && (
        <Button
          fullWidth
          onClick={() => pricing.openAddItems()}
          startIcon={<SearchRounded />}
          sx={{
            justifyContent: 'flex-start',
            p: 2,
            border: '1px solid',
            borderColor: 'var(--outlineGrey)',
            borderRadius: '10px',
            textTransform: 'none',
            color: 'var(--darkGrey)',
            fontFamily: 'Montserrat',
            '&:hover': {
              borderColor: 'var(--darkGrey)',
              backgroundColor: 'transparent',
            },
            typography: 'body2',
          }}>
          {pricing.searchItemsLabel}
        </Button>
      )}

      <CheckoutFormPricingTable {...pricing.summary} />
    </Box>
  );
}
